import Checkbox from "@mui/material/Checkbox";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import ListItemText from "@mui/material/ListItemText";
import MenuItem from "@mui/material/MenuItem";
import OutlinedInput from "@mui/material/OutlinedInput";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import * as React from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { CountryRef } from "../../../models/countries";

export const CountriesQuickfilter = ({ countries, setCountryIds }: Props) => {
  const { t } = useTranslation();
  const tRP = "components.quickfilters.countries"; // tRP - translation root path

  const [checkedCountries, setCheckedCountries] = useState<CountryRef[]>(countries ?? []);

  const handleChangeCountries = (event: SelectChangeEvent<typeof checkedCountries>) => {
    const value = event.target.value as CountryRef[];
    const checkedIds = value.map((el) => el.id);
    setCheckedCountries(value as CountryRef[]);
    setCountryIds(checkedIds);
  };

  return (
    <div>
      <FormControl sx={{ m: 1 }}>
        {countries?.length ? (
          checkedCountries?.length ? (
            <InputLabel id={"multiple-checkbox-label"}>{t(`${tRP}.countries_filter_label`)}</InputLabel>
          ) : (
            <InputLabel
              id={"multiple-checkbox-label"}
              shrink={true}
            >
              {t(`${tRP}.countries_filter_label`)}
            </InputLabel>
          )
        ) : (
          <InputLabel
            id={"multiple-checkbox-label"}
            shrink={false}
          >
            {t(`${tRP}.no_countries_options`)}
          </InputLabel>
        )}
        <Select
          labelId="multiple-checkbox-label"
          id="multiple-checkbox"
          multiple
          value={checkedCountries}
          onChange={handleChangeCountries}
          input={countries?.length ? <OutlinedInput label={t(`${tRP}.countries_filter_label`)} /> : undefined}
          renderValue={(selected) => {
            if (!selected.length && !!countries?.length) {
              return t(`${tRP}.default_label`);
            }

            return selected.map((el) => el?.name).join(", ");
          }}
          MenuProps={{
            PaperProps: {
              style: {
                minWidth: "200px",
                display: countries?.length ? "inherit" : "none",
              },
            },
          }}
          sx={{ width: 200 }}
          displayEmpty={true}
          notched={true}
        >
          {countries?.map((country) => (
            <MenuItem
              key={country?.id}
              value={country as any}
            >
              <Checkbox checked={checkedCountries.indexOf(country) > -1} />
              <ListItemText primary={country?.name} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
};

type Props = {
  countries: CountryRef[] | null;
  setCountryIds: React.Dispatch<React.SetStateAction<string[]>>;
};
